import { useState, useEffect, useCallback } from 'react';
import { apiClient } from '../services/apiClient';

interface UseNextReportNumberResult {
  nextNumber: string | null;
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

export const useNextReportNumber = (agentId: string | undefined): UseNextReportNumberResult => {
  const [nextNumber, setNextNumber] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchNextNumber = useCallback(async () => {
    if (!agentId) {
      setNextNumber(null);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const number = await apiClient.getNextReportNumber(agentId);
      setNextNumber(number);
    } catch (err) {
      setError('Error fetching next report number');
      setNextNumber(null);
    } finally {
      setLoading(false);
    }
  }, [agentId]);

  useEffect(() => {
    fetchNextNumber();
  }, [fetchNextNumber]);

  return {
    nextNumber,
    loading,
    error,
    refresh: fetchNextNumber,
  };
};
